// Shared with App\Classes\VehicleMake so agent imports can only ever resolve to
// a make that is selectable here. Edit resources/data/vehicle-makes.json.
import vehicleMakes from '../../data/vehicle-makes.json';

export default vehicleMakes;
